<template>
  <slice
    :id="block._key"
    class="slice--texte container"
    @in="$emit('in')"
    @out="$emit('out')"
  >
    <div class="row-md justify-center slice--texte__inner">
      <div class="col-md-8 col-xlg-6">
        <portable-text v-if="isFilled" :blocks="block.text" />
      </div>
    </div>
  </slice>
</template>

<script>
import Slice from '@/components/Slices/Slice'
import PortableText from '@/components/RichText/PortableText'

export default {
  title: 'BlockText',
  components: { PortableText, Slice },
  props: {
    block: { type: Object, required: true },
  },
  computed: {
    isFilled() {
      return this.block.text && this.block.text.length > 0
    },
  },
}
</script>

<style lang="scss">
.slice--texte {
  &__inner {
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
